<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <form id="FormProductoPresentacion" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <button @click="AbreModal" type="button" class="btn btn-primary"><i class="fa fa-plus"></i> Agregar Presentación</button>
                                            </div>
                                        </div>

                                        <div class="table-responsive">
                                            <table class="table align-items-center mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Material</th>
                                                        <th>Unidad</th>
                                                        <th width="5%">Sub Unidad</th>
                                                        <th width="10%">Precio Material</th>
                                                        <th>Cantidad</th>
                                                        <th width="15%">Precio Total</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item,index) in PresentacionesSeleccionadas" :key="index">
                                                        <td>
                                                            <input disabled type="text" class="form-control" v-model="item.material.Nombre">
                                                        </td>
                                                        <td>
                                                            <input disabled type="text" class="form-control" v-model="item.unidad_material.Nombre">
                                                        </td>
                                                        <td>
                                                            <input disabled type="text" class="form-control" v-model="item.SubUnidadNombre">
                                                        </td>
                                                        <td>
                                                            <input disabled type="text" class="form-control" v-model="item.Costo">
                                                        </td>
                                                        <td>
                                                            <div class="input-group">
                                                                <input type="text" class="form-control" v-model="item.Cantidad" @input="$number_decimal($event,item,'Cantidad');Calcular(item,index);">
                                                                <div class="input-group-append">
                                                                    <span class="input-group-text">{{ item.sub_unidad_material.SubUnidad }}</span>
                                                                </div>
                                                            </div>
                                                            <CValidation v-if="errorvalidacion[item.IdMaterialPresentacion]" :Mensaje="'*'+errorvalidacion[item.IdMaterialPresentacion].Cantidad[0]"/>
                                                        </td>
                                                        <td>
                                                            <input disabled type="text" class="form-control" v-model="item.PrecioTotal">
                                                        </td>
                                                        <td>
                                                            <button type="button" class="btn btn-link text-danger text-gradient px-3 mb-0" @click="EliminarPresentacion(item.IdMaterialPresentacionxProveedor)">
                                                                <i class="far fa-trash-alt me-2" aria-hidden="true"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <CBtnSave :poBtnSave="oBtnSave" />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </template>
                </CLoader>
            </template>
        </CList>
        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSaveModal">
            <template slot="Form">
                <FormModal 
                :poBtnSave="oBtnSaveModal" 
                :objPresentacionesSeleccionadas="PresentacionesSeleccionadas"
                :objPresentacionesRegistradas="ProductoPresentaciones"></FormModal>
            </template>
        </CModal>
    </div>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
import FormModal from '@/views/modulos/almacen/productoPresentacion/PresentacionesModal.vue';
const EmitEjecuta = 'seccionProductoPresentacion';
const EmitEjecuta2 = 'seccionPresentacion';
export default {
    name: 'FormProductoPresentacion',
    props: ['Id','Obj'],
    components:{
        FormModal
    },
    data(){
        return{
            ConfigList:{
                Title: 'Formulario de Presentaciones',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				TitleFirst: this.Obj.Nombre,
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            ConfigModal:{
                ModalTitle: "Asignar Presentación",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta2,
                // ModalSize:'xl'
                FullScreen: true,
                ShowFooter:false
            },
			oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'ProductoPresentacion',
                EmitSeccion: EmitEjecuta,
                ShowBtnCancel:false
            },
            oBtnSaveModal: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
                TxtBtnSave:'Asignar'
            },
            objProductoPresentacion: {
				IdProductoPresentacion: 0,
                IdProducto:0,
				IdMaterialPresentacion: 0,
                IdProveedor:0,
                Cantidad:0,
                PrecioTotal:0,
				// IdUnidadMaterial: 0,
				// IdSubUnidadMaterial: 0,
				Presentaciones:[]
            },
            segurity: {},
			masks: { input: 'YYYY-MM-DD' }, // quitar sino lleva fecha 
            errorvalidacion: [],
            errorvalidacion2: [],
			Emit: EmitEjecuta,
            // PROPIO
            PresentacionesSeleccionadas:[],
            ProductoPresentaciones:[]
            // ListaFiltro:[]
        }
    },
    methods: {
        Guardar(){
            this.oBtnSave.DisableBtn = true;
            let formData=new FormData();
            formData.set('IdProducto',this.objProductoPresentacion.IdProducto);
            formData.set('PresentacionesSeleccionadas',JSON.stringify(this.PresentacionesSeleccionadas));
            this.$http.post("productoPresentaciones",formData
            ).then((res)=>{
                this.EjecutaConExito(res);
            }).catch((err)=>{
                this.EjecutaConError(err);
            })
        },
        EjecutaConExito(res){
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
            // this.GuardarPrecioProducto(res);
        },
        EjecutaConError(err){
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar(){

        },
        Limpiar(){

        },
        Regresar(){
            this.$router.push({name:'ProductoPresentacion',params:{pOrigen:this.objProductoPresentacion}});
        },
        ListaProductoPresentaciones(){
            this.$http.get("productoPresentacionesSimple",{
                params:{
                    IdProducto:this.objProductoPresentacion.IdProducto
                }
            }).then((res)=>{
                this.ProductoPresentaciones=res.data.data;
            })
        },
        AbreModal(){
            this.bus.$emit('NewModal_'+this.ConfigModal.EmitSeccion,0,this.objProductoPresentacion);
        },
        AniadirPresentacion(item){
            item.PrecioTotal=0;
            this.PresentacionesSeleccionadas.push(item);
            this.bus.$emit('CloseModal_'+this.ConfigModal.EmitSeccion);
            this.PresentacionesSeleccionadas.map((element)=>{
                element.SubUnidadNombre=element.sub_unidad_material.Cantidad + ' '+element.sub_unidad_material.SubUnidad;
            })
        },
        Calcular(item,index){
            Number(item.Cantidad);
            let Total=(isNaN(item.Cantidad)) ? 0 : Number(parseFloat((parseFloat(item.Costo)*parseFloat(item.Cantidad))/parseFloat(item.sub_unidad_material.Cantidad))).toFixed(2);
            this.PresentacionesSeleccionadas[index].PrecioTotal=Total;
        },
        EliminarPresentacion(index){
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    let IndiceEliminar=this.PresentacionesSeleccionadas.findIndex((element)=>element.IdMaterialPresentacionxProveedor==index);
                    this.PresentacionesSeleccionadas.splice(IndiceEliminar,1);
                } 
            });
        },
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);

        this.bus.$off('SeleccionarPresentacion');

        // this.bus.$off('TraerComisionesSeleccionadas');
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();
        this.objProductoPresentacion.IdProducto=this.Obj.IdProducto;
        this.objProductoPresentacion.Nombre=this.Obj.Nombre;
        this.ListaProductoPresentaciones();

        if(this.Id!='') 
        {
            this.Recuperar();
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {

            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });

        this.bus.$on('SeleccionarPresentacion',(item)=>{
            this.AniadirPresentacion(item);
        });

    },
}
</script>